import React from 'react';
import PropType from 'prop-types';
import './field-text.css';

const FieldText = props => {
  const { id, label, placeholder, className, value, onChange, maxLength } = props;

  return (
    <div className={`field-text ${className}`}>
      <div className="field-text__label-container">
        <label className="field-text__label" htmlFor={id}>
          {label}
        </label>
        <div className="field-text__field-text">
          <input
            id={id}
            type="text"
            placeholder={placeholder}
            defaultValue={value}
            maxLength={maxLength}
            onChange={onChange}
            className="field-text__input pure-u-24-24"
          />
        </div>
      </div>
    </div>
  );
};

FieldText.defaultProps = {
  id: '',
  label: '',
  placeholder: 'Select ...',
  className: '',
  value: '',
  onChange: '',
  maxLength: 250,
};

FieldText.propTypes = {
  id: PropType.string,
  label: PropType.string,
  placeholder: PropType.string,
  className: PropType.string,
  value: PropType.any,
  onChange: PropType.any,
  maxLength: PropType.number,
};

export default FieldText;
